module.exports = __webpack_public_path__ + "static/media/maxi-coffee.fc126eb9.jpg";